import type { Theme } from "@mui/material/styles";

const styles = (theme: Theme) => ({
  root: {
    maxWidth: 500,
    minHeight: "auto",
  },
  heading: {
    paddingTop: 10,
    paddingBottom: 5,
  },
  linkColumn: {
    maxHeight: 120,
    overflowY: "auto",
    "&.sb-dialog--contentBody": {
      padding: "2rem 3.2rem 0rem 3.2rem !important",
    },
  },
  linkButton: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
    textAlign: "left",
    "&.py2": {
      paddingTop: "0.5rem !important",
      paddingBottom: "0rem !important",
    },
    "&.mb2": {
      marginBottom: "0rem !important",
    },
  },
  "&.button:focus": {
    outline: "none !important",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
    position: "fixed",
    top: 0,
    left: 0,
  },
  sbuxLogo: {
    height: 300,
    width: 300,
    [theme.breakpoints.down("md")]: {
      height: "auto",
      width: "auto",
    },
  },
});

export default styles;
